import { render, staticRenderFns } from "./NoLocationsConnected.vue?vue&type=template&id=6b56f5a9&scoped=true"
import script from "./NoLocationsConnected.vue?vue&type=script&lang=js"
export * from "./NoLocationsConnected.vue?vue&type=script&lang=js"
import style0 from "./NoLocationsConnected.vue?vue&type=style&index=0&id=6b56f5a9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b56f5a9",
  null
  
)

export default component.exports